import Http from "./base-http";

class Address extends Http {
  getAllTimezones() {
    return this.get('/alltimezones');
  }
}
const addressObj = new Address({
  modelUrlPrefix : "address"
});

export default addressObj;